import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTheme } from '@mui/material';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React from 'react';

import { useTopLevelMenuStyles } from '../menuStyles/topLevelMenuStyles';

import { IMenuHeaderProps } from './menuHeaderProps';

export const TextMenuHeader = (props: IMenuHeaderProps) => {
  const theme = useTheme();
  const styles = useTopLevelMenuStyles(theme);
  const { ariaControls, href, labelText, open, showChevron, titleText, handleToggle } = props;

  return (
    <Tooltip title={titleText} placement="bottom-start">
      <Link
        data-testid="menu-link"
        className={styles.link}
        aria-label={labelText}
        aria-controls={ariaControls}
        aria-haspopup="true"
        underline="none"
        href={href}
        onClick={(e: React.MouseEvent<HTMLAnchorElement>) =>
          handleToggle ? handleToggle(e) : null
        }
      >
        <Typography
          component="span"
          variant="subtitle1"
          className={styles.text}
          aria-label={labelText}
          aria-controls={ariaControls}
          aria-haspopup="true"
        >
          {labelText}

          {showChevron && (
            <FontAwesomeIcon className={styles.chevron} icon={open ? faChevronUp : faChevronDown} />
          )}
        </Typography>
      </Link>
    </Tooltip>
  );
};
